<template>
  <div class="col-12">
    <Search
      :allowFields="$lang.final_report_fields"
      :allowCollapse="false"
      :url="url"
      :title="$lang.showFinalReportList"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :visibleAdd="false"
      :allowEdit="false"
      :filterCatch="true"
      :showTotals="true"
      :defaultViewCount="10"
      ref="finalReport"
      :dynamicButtons="availableButtons"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "final-report-search",
  components: {
    Search,
  },
  data() {
    return {
      availableButtons: [
        {
          id: "1",
          name: "editView",
          iconFont: "fas fa-users text-primary",
          text: this.$lang.finalReportVotesGroupTooltip,
          click: this.goToDetailVotesGroup,
        },
        {
          id: "1",
          name: "editView",
          text: this.$lang.finalReportVotesTooltip2,
          click: this.goToDetail2,
        },
      ],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["report", "final_report"]);
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    goToDetail(item) {
      let routeData = this.$router.resolve({
        name: "finalReportVotes",
        params: {
          code: item.parvandeh_code,
        },
      });

      window.open(routeData.href, "_blank");
    },
    goToDetailVotesGroup(item) {
      const code = pathOr(null, ["parvandeh", "code"], item);
      let routeData = this.$router.resolve({
        name: "finalReportVotesGroup",
        params: { code },
      });

      window.open(routeData.href, "_blank");
    },
    goToDetail2(item) {
      const code = pathOr(null, ["parvandeh", "code"], item);
      let routeData = this.$router.resolve({
        name: "finalReportVotes2",
        params: { code },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
